<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>会员管理</el-breadcrumb-item>
			<el-breadcrumb-item>积分管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="审核状态">
				<el-select v-model="item.type" clearable placeholder="请选择" size="small">
					<el-option v-for="item in options" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="success" @click="excelOut" size="medium">导出</el-button>
				<el-button type="success" @click="excelIn" size="medium" v-auth="['store/member.jifen/import']">导入</el-button>
				<el-button type="success" @click="down" size="medium">下载积分导入模板</el-button>
			</el-form-item>
		</el-form>
		<div style="margin-bottom: 20px;">
			<el-button type="primary" @click="audit" size="medium" v-auth="['admin/member.jifen/audit']">批量审核</el-button>
		</div>
		<!-- 导入数据 -->
		<el-dialog title="导入数据" :visible.sync="dialogVisibleFile" width="30%"
			:before-close="handleClosedialogVisibleFile">
			<span style="display: flex;">
				<el-form :inline="true" :model="ads">
					<el-form-item label="上传文件" style="width: 100%;">
						<el-upload class="upload-demo" ref="upload" :action="app_url + '/store/member.jifen/import'"
							:data="{store_id:ads.store_id,source:ads.source}" :on-error="uploadError"
							:headers="{'Access-Token': token}" :on-remove="handleRemove"
							:file-list="fileList" :auto-upload="false" accept=".xlsx" :limit="1">
							<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
							<div slot="tip" class="el-upload__tip">请选择上传的Excel文件</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="积分来源">
						<el-input v-model="ads.source" placeholder="请输入积分来源"></el-input>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitUpload">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 批量审核 -->
		<el-dialog title="批量审核" :visible.sync="dialogVisible" width="30%" :before-close="handleClosedialogVisible">
			<span style="display: flex;">
				<el-form :inline="true" :model="audits">
					<el-form-item label="审核结果">
						<el-radio v-model="audits.audit" label="1">通过</el-radio>
						<el-radio v-model="audits.audit" label="0">驳回</el-radio>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sure">确 定</el-button>
			</span>
		</el-dialog>
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="mobile" label="用户">
				<template slot-scope="scope">
					<span>{{scope.row.real_name}},{{scope.row.mobile}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="jifen" label="积分"></el-table-column>
			<el-table-column label="店铺名称">
				<template slot-scope="scope">
					<span v-if="scope.row.store">{{scope.row.store.name}}</span>
				</template>
			</el-table-column>
			<el-table-column label="审核状态">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.audit_state == 1">待审核</el-tag>
					<el-tag type="success" v-else-if="scope.row.audit_state == 2">已通过</el-tag>
					<el-tag type="danger" v-else>已驳回</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="source" label="来源"></el-table-column>
			<el-table-column prop="created_date" label="导入时间"></el-table-column>
			<el-table-column label="操作" width="170">
				<template slot-scope="scope">
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1,
				dialogVisibleFile: false,
				token: localStorage.token,
				ads: {},
				fileList: [],
				storeOptions: [],
				options: [{
					name: '全部',
					id: '0'
				}, {
					name: '待审核',
					id: '1'
				}, {
					name: '已通过',
					id: '2'
				}, {
					name: '已驳回',
					id: '3'
				}],
				item: {},
				// 审核
				audits: {
					ids: []
				},
				dialogVisible: false,
				multipleSelection: []
			}
		},
		created() {
			this.loadList()
		},
		methods: {
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''
				res = await this.axios.get('/store/member.jifen/listImport', {
					params: {
						page: this.page,
						limit: this.pageSize,
						store_id: this.item.store_id,
						state: this.item.type
					}
				})
				this.list = res.data.list.data
				this.total = res.data.list.total
				this.isLoad = !this.isLoad
			},

			sizeReload(val) {
				this.pageSize = val
				this.loadList()
			},
			// 分页
			pageReload(val) {
				this.page = val
				this.loadList()
			},
			excelIn() {
				this.fileList = []
				this.dialogVisibleFile = true
			},
			handleClosedialogVisibleFile() {
				// this.$refs.upload.clearFiles();
				this.ads = {}
				this.dialogVisibleFile = false
			},
			uploadError() {
				this.$message.error({
					message: '导入失败'
				});
			},

			handleRemove(file, fileList) {
				this.fileList = []
			},
			submitUpload() {
				this.$refs.upload.submit()
				this.handleClosedialogVisibleFile()
				this.loadList()
			},
			submit() {
				this.page = 1
				this.loadList()
			},
			// 审核
			// 审核和批量审核
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			audit() {
				this.dialogVisible = true
			},
			handleClosedialogVisible() {
				this.audits.audit = ''
				this.dialogVisible = false
			},
			sure() {
				this.isLoad = !this.isLoad
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					this.audits.ids.push(item.id)
				}

				this.axios.post('/store/member.jifen/audit', this.audits)
						.then(res => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '批量审核完成'
							});
							this.handleClosedialogVisible()
							this.loadList()
						}).catch(err => {
					this.isLoad = !this.isLoad
				})
			},
			down(){
				window.open('https://jmshops.oss-cn-shenzhen.aliyuncs.com/newmb.xlsx')
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/store/member.jifen/importListExport', this.item)
						.then(res => {
							this.isLoad = false
							if (res.code == 1) {
								import('@/vendor/Export2Excel.js').then(excel => {
									var expCellName = res.data.expCellName
									var tHeader = []
									var filterVal = []
									for (var i in expCellName) {
										tHeader.push(expCellName[i])
										filterVal.push(i)
									}
									const expTableData = res.data.expTableData
									const data = this.formatJson(filterVal, expTableData)
									var d = new Date()
									var year = d.getFullYear()
									var month = d.getMonth()
									var date = d.getDate()
									var hour = d.getHours()
									var minute = d.getMinutes()
									var second = d.getSeconds()
									month = month < 10 ? '0' + month : month
									date = date < 10 ? '0' + date : date
									hour = hour < 10 ? '0' + hour : hour
									minute = minute < 10 ? '0' + minute : minute
									second = second < 10 ? '0' + second : second
									excel.export_json_to_excel({
										header: tHeader,
										data,
										filename: '用户积分充值使用汇总导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
		}

	}
</script>

<style>
</style>
